import { useCompanyThemingSettings } from './useCompanyThemingSettings';
import { useResolvedTheme } from './useResolvedTheme';

/**
 * Gets the font color from company theming settings based on the resolved theme.
 * Returns the light or dark font color depending on whether the user is in light or dark mode.
 *
 * @returns The font color string, or empty string if not available
 */
export const useCompanyThemingFontColor = (): string => {
	const { data: companyThemingSettings } = useCompanyThemingSettings();
	const resolvedTheme = useResolvedTheme();

	const fontColor =
		resolvedTheme === 'light'
			? companyThemingSettings?.fontColorLight
			: companyThemingSettings?.fontColorDark;

	return fontColor ?? '';
};

/**
 * Gets the navbar color from company theming settings based on the resolved theme.
 * Returns the light or dark navbar color depending on whether the user is in light or dark mode.
 *
 * @returns The navbar color string, or empty string if not available
 */
export const useCompanyThemingNavbarColor = (): string => {
	const { data: companyThemingSettings } = useCompanyThemingSettings();
	const resolvedTheme = useResolvedTheme();

	const navbarColor =
		resolvedTheme === 'light'
			? companyThemingSettings?.navbarColorLight
			: companyThemingSettings?.navbarColorDark;

	return navbarColor ?? '';
};
